import { createContext } from 'react';

export interface TopBannersHeightContextValue {
  topBannersHeight: number;
  setTopBannersHeight: (height: number) => void;
}

export const TopBannersHeightContext =
  createContext<TopBannersHeightContextValue>({
    topBannersHeight: 0,
    setTopBannersHeight: () => {},
  });
